import { render, staticRenderFns } from "./personTagCloud.vue?vue&type=template&id=06dcf013&scoped=true"
import script from "./personTagCloud.vue?vue&type=script&lang=js"
export * from "./personTagCloud.vue?vue&type=script&lang=js"
import style0 from "./personTagCloud.vue?vue&type=style&index=0&id=06dcf013&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dcf013",
  null
  
)

export default component.exports